import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconChevronSvg } from "./IconChevronSvg.mjs";
import { root, up, left, right } from "./IconChevron.css.mjs";
const IconChevron = ({
  direction = "down",
  ...props
}) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: ({ className, ...svgProps }) => /* @__PURE__ */ jsx(
  Box,
  {
    component: IconChevronSvg,
    className: [
      root,
      className,
      {
        [up]: direction === "up",
        [left]: direction === "left",
        [right]: direction === "right"
      }
    ],
    ...svgProps
  }
) });
export {
  IconChevron
};
